import CurativeRequirement from './CurativeRequirement';

export class Runsheet {
    id: number;
    projectId: number;
    friendlyName: string;
    titleAttorney: string;
    clientLandman: string;
    wellName: string;
    documentNumber: string;
    receivedFromClientDate?: Date;
    receivedFromClientUserId?: number;
    assignedToLandmanDate?: Date;
    assignedToLandmanUserId?: number;
    receivedByLandmanDate?: Date;
    receivedByLandmanUserId?: number;
    sentToLandCompanyDate?: Date;
    sentToLandCompanyUserId?: number;
    sentToClientDate?: Date;
    sentToClientUserId?: number;
    titleOpinionReceivedDate?: Date;
    titleOpinionReceivedUserId?: number;
    titleClearedDate?: Date;
    receivedByDlcDate?: Date;
    receivedByDlcUserId?: number;
    statusTypeCheck?: string;
    statusTypeCheckAssignedByUserId: number;
    titleClearedUserId?: number;
    clientRequestedUpdateDate?: Date;
    clientRequestedUpdateUserId?: number;
    updateRequestCompletedDate?: Date;
    updateRequestCompletedUserId?: number;
    onHold: boolean;
    onHoldDate?: Date;
    comments: string;

    attachedTractIds: number[];
    curativeRequirements: CurativeRequirement[];
}

export class RunSheetSummary {
    id: number;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/Runsheets.ts